import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import MotifNav from '@ey/canvascoreservices/MotifNav';
import NotificationsCenter from '../../Notifications/NotificationsCenter';
import MoreMenuOptions from './MoreMenuOptions';
import {MenuIconOptions} from './MenuIconOptions';
import {getTheme, labels} from '../../../util/uiconstants';
import * as QueryString from 'query-string';
import _ from 'lodash';
import styled from 'styled-components';
import {adobeAnalytics} from '@ey/voltron-analytics';
import {clickActionArgs} from '../Adobe Analytics/actionHelpers.js';
import {
	controlTypes,
	eventTypes,
	locationInPages,
	clickActionNames
} from '../Adobe Analytics/constants.js';

export default function TopBarNav(props) {
	const mode = getTheme();
	const params = QueryString.parse(window.location.search);

	const userSettings = useSelector((store) => store.userSettings);
	const featureConfigurations = useSelector(
		(store) => store.featureConfiguration
	);

	const [triggerNotification, setNotificationStatus] = useState(true);
	const [showIcons, setShowIcons] = useState(true);
	const [iconOptions, setIconOptions] = useState([]);
	const [showNotificationsCenter, setShowNotificationsCenter] = useState(true);
	const trackEvent = adobeAnalytics.useAdobeAnalyticsTrack();

	useEffect(() => {
		if (!_.isEmpty(featureConfigurations) && !_.isEmpty(userSettings)) {
			const isGuestUser = userSettings?.data?.isguestuser;
			setIconOptions(
				MenuIconOptions(featureConfigurations, isGuestUser, trackEvent)
			);
			if (isGuestUser !== undefined) {
				setShowNotificationsCenter(!isGuestUser);
			} else {
				setShowNotificationsCenter(false);
			}
		}
	}, [featureConfigurations, userSettings]);

	useEffect(() => {
		let path = window.location.pathname;
		if (path === '/rejectIndependenceOnlyEngagementInvite') {
			setShowIcons(false);
		} else {
			if (!_.isEmpty(userSettings)) {
				setShowIcons(
					userSettings.data &&
						Object.keys(userSettings?.data)?.length > 0 &&
						(params.showNavIcons === 'true' ||
							params.showNavIcons === undefined)
				);
			}
		}
	}, [userSettings]);

	const notificationRender = () => {
		return (
			<section title={labels.notifications} className="notifications">
				{showNotificationsCenter && (
					<NotificationsCenter
						key="topNavEyUserNotificationsCenter"
						id="topNavEyUserNotificationsCenter"
						{...props}
						triggerNotification={triggerNotification}
						setNotificationStatus={setNotificationStatus}
						theme={mode}
					/>
				)}
			</section>
		);
	};

	const handleLogoClick = () => {
		// Adobe Analytics Click Tracking
		trackEvent(
			eventTypes.clickAction,
			clickActionArgs(
				clickActionNames.canvas,
				controlTypes.icon,
				locationInPages.topNav
			)
		);
	};

	return (
		<StyledMotifNav className="motif-no-padding">
			<MotifNav
				applicationName={labels.canvas}
				useMotifMenu={showIcons}
				applicationNameRedirectUrl={'/'}
				disableLogo={false}
				showIconLinks={showIcons}
				copyrightMessage={labels.copyrightMessage}
				hideOffline={true}
				topNavLinks={iconOptions}
				showMoreMenuOptions
				showSelectorDropdown={false}
				showNotifications={
					featureConfigurations &&
					featureConfigurations.features &&
					featureConfigurations.features.enableNotifications
				}
				notifications={notificationRender}
				showSettings={false}
				showSearchBox={false}
				showAvatar={false}
				onLogoClick={handleLogoClick}
			>
				<MoreMenuOptions
					featureConfiguration={featureConfigurations}
					userSettings={userSettings?.data}
				/>
			</MotifNav>
		</StyledMotifNav>
	);
}

TopBarNav.displayName = 'TopBarNav';

const StyledMotifNav = styled.section`
	.notifications {
		padding-right: var(--px-35-5);
	}
	.MoreMenuContainer {
		.motif-menu {
			.motif-menu-list-item a:hover {
				cursor: pointer;
			}
			svg {
				margin: calc(var(--px-3) * -1) var(--px-5) 0 var(--px-5);
			}
		}
	}
`;
